import Dexie from 'dexie';
import {sha256} from '../infrastructure/backup/snapshot';
/** Only external hashing needs keep-alive; never waitFor a nested database command. */
export function transactionFingerprint(input:unknown) {
  const hash=sha256(new Blob([JSON.stringify(input)]));
  return Dexie.currentTransaction ? Dexie.waitFor(hash) : hash;
}
